import template from './children-activities.html'

export let childrenActivities = {
	bindings: {
		parent  : '<',
		children: '<',
		activity: '=',
		planning: '<',
	},
	template    : template,
	controllerAs: 'vm',
	controller  : [ '$cookies', '$stateParams', 'GlobalConfig', 'WorkPlanModalSrv', 'CssClasses', 'Validations', 'Setters', 
		'Ramda', 'GlobalSrv', '$scope', '$rootScope',
		function childrenActivitiesCtrl ($cookies, $stateParams, GlobalConfig, WorkPlanModalSrv, CssClasses, 
			Validations, Setters, Ramda, GlobalSrv, $scope, $rootScope) {
			const R = Ramda
			const minorActivityId = GlobalConfig.minorActivityId
			const textColor = CssClasses.textColor
			const currentStage = ($stateParams.currentStage) ? $stateParams.currentStage : $stateParams.stage
			const teacherId = Setters.importGlobal($stateParams, 'teacherId', $cookies)
			const workplanId = Setters.importGlobal($stateParams, 'workplanId', $cookies)
			let columns = Validations.isActivitiesType(this.parent) ? 'col-md-3' : 'col-md-2'
			let colExecution = Validations.inExecution(currentStage) ? 'col-md-4' : 'col-md-6'
			let colActions = Validations.inExecution(currentStage) ? 'col-md-4' : 'col-md-2'
			let text = Validations.inExecution(currentStage) ? 'text-center' : 'text-center'

			angular.extend(this, {
				// variables
				inExecution          : Validations.inExecution(currentStage),
				inEvaluation         : Validations.inEvaluation(currentStage),
				inReviewExecution    : Validations.inReviewExecution(currentStage),
				isActivitiesType     : Validations.isActivitiesType(this.parent),
				isSubjectType        : Validations.isSubjectType(this.parent),
				contentHeaderCSS     : [ colExecution, 'no-padding', 'text-center', 'font-normal', 'text-sm' ],
				headingCSS           : [ columns, 'no-padding', 'text-center', 'text-sm', 'font-normal' ],
				contentCSS           : [ columns, 'no-padding', 'text-center', 'text-sm', textColor.blue ],
				acctionCCS           : [ 'col-md-2', 'no-padding', text, 'text-gris-dark', 'text-sm' ],
				actionHeaderCSS      : [ colActions, 'no-padding', 'text-center', 'text-sm' ],
				contentNameCSS       : [ colExecution, 'no-padding' ],
				executionFinish      : 1,
				disableEdit          : 'disabled',
				isBlocked            : 1,
				// methods
				addActivity          : addActivity,
				executionEntries     : executionEntries,
				registerExecution    : registerExecution,
				editChildrenExecution: editChildrenExecution,
				isDisabled           : isDisabled,
				inHistory            : $stateParams.inHistory,
			})

			const setActivityId = R.curry((children) => {
				switch (children.type) {

				case 'planning':
					return minorActivityId.planning
				case 'teaching':
					return minorActivityId.teaching
				
				}
			})(this.children)

			const setActivityHeader = R.curry((children, parent, id) => {
				return {
					idActivityParent: parent.workplanTeacherActivityId,
					idTeacher       : teacherId,
					idWorkPlan      : workplanId,
					activityId      : id,
					asignatureId    : parent.asignatureId,
					listType        : children.type,
					children        : children,
				}
			})(this.children, this.parent)

			this.$onInit = () => {
				this.executionFinish = this.parent.executionFinish

				if (this.parent.origin == 3) {
					this.isBlocked = (this.parent.checkStatus == 0 && this.parent.origin == 3)
				} else {
					this.isBlocked = this.parent.isBlocked
				}

				if (this.executionFinish || this.isBlocked) {
					this.disableEdit = 'disabled'
				} else {
					this.disableEdit = ''
				}
			}

			function addActivity (children, parent) {
				WorkPlanModalSrv.setVariable(setActivityHeader(setActivityId))
				WorkPlanModalSrv.addActivity().then((promise) => {
					let add = WorkPlanModalSrv.getVariable()

					add ? children.push(add) : console.log('no activity was added')
					children.totalExecutedHours += add.hoursExecuted
					$rootScope.$emit('rootScope:execHours', 'execHours!')
				})
			}

			function registerExecution (children, action) {
				WorkPlanModalSrv.setVariable({ children: children, action: action })
				WorkPlanModalSrv.registerExecution().then((promise) => {
					let data = WorkPlanModalSrv.getVariable()

					if (data != null) {
						children.hoursExecuted += data.hoursExecuted
						this.children.totalExecutedHours += data.hoursExecuted
						this.activity.totalHoursExecuted += data.hoursExecuted
						$rootScope.$emit('rootScope:execHours', 'execHours!')
					}
				})
			}

			function executionEntries (parent, children) {
				let parentActivity = children

				parentActivity.selectedActivityId = children.workplanTeacherActivityId
				parentActivity.asignatureName = children.name
				WorkPlanModalSrv.setVariable(parentActivity)
				WorkPlanModalSrv.executionEntries()
			}

			function editChildrenExecution (parent, children) {
				WorkPlanModalSrv.setVariable(children.hoursExecuted)
				WorkPlanModalSrv.editChildrenExecution({ children: children }).then((promise) => {
					let data = WorkPlanModalSrv.getVariable()

					if (data != null) {
						this.children.totalExecutedHours += children.hoursExecuted - data
						this.activity.totalHoursExecuted += children.hoursExecuted - data
						$rootScope.$emit('rootScope:execHours', 'execHours!')
					}
				})
			}

			function isDisabled (activity) {
				if ((activity.origin == 3 && this.isBlocked)) {
					return 'disabled'
				} else if (this.executionFinish || this.isBlocked) {
					return 'disabled'
				} else if (activity.hoursExecuted === 0) {
					return '' //vignesh change
				}
			}

			GlobalSrv.subscribe($scope, $rootScope, 'isBlocked', (data) => {
				this.isBlocked = data
			})

			GlobalSrv.subscribe($scope, $rootScope, 'hoursChanged', (hours) => {
				if (this.isActivitiesType) {
					this.children[0].hoursExecuted = hours
				}
			})
		},
	] }


// WEBPACK FOOTER //
// ./src/app/u-faculty/components/activities-review/activity-details/children-activities.js